import { css } from '@emotion/react'

export const instructionsRowContainer = css`
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  width: 100%;
`

export const instructionsIconContainer = css`
  width: 24px;
  height: 100%;
`

export const instructionsIcon = css`
  width: 24px;
  height: 24px;
`
